<div class="municipality-container">
    <div><label class="labelTitle" for="municipality">1. {{ 'PREVIEW_SPACE.COMMUNITY_SELECT' | translate }}</label></div>
    <div><app-cpm [comunidad]=true [provincia]=false [municipio]=false></app-cpm></div>
</div>